import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { CreateMultiLegShippingEstimateByFuelResponse } from '@lune-climate/lune'
import { Table } from '@lune-fe/lune-ui-lib'
import { FC } from 'react'

import { getFormattedAmount } from '../../utils'

export const LegsByFuelPdfTable: FC<{ estimate: CreateMultiLegShippingEstimateByFuelResponse }> = ({
    estimate,
}) => {
    useLingui()

    const legFormattedAmount = (
        leg: CreateMultiLegShippingEstimateByFuelResponse['legs'][number],
    ): string => {
        const formattedAmount = getFormattedAmount(leg.mass.amount)
        return `${formattedAmount.displayAmount} ${formattedAmount.amountUnit}CO₂e`
    }

    return (
        <Table.TableContainer data-testId={'cart-table'}>
            <Table
                sx={{
                    '.MuiTableCell-root > div': {
                        minHeight: '48px !important',
                    },
                }}
            >
                <Table.TableHead>
                    <Table.TableRow>
                        <Table.TableCell colSize={3}>{t`Leg`}</Table.TableCell>
                        <Table.TableCell colSize={6}>{t`Fuel consumption`}</Table.TableCell>
                        <Table.TableCell colSize={3} alignEnd align="right">
                            {t`Emissions`}
                        </Table.TableCell>
                    </Table.TableRow>
                </Table.TableHead>
                <Table.TableBody>
                    {estimate.legs.map((leg, index) => {
                        const fuelConsumed = estimate.request.legs[index].fuelConsumedLitres
                        const name = leg.emissionFactor.name

                        return (
                            <Table.TableRow key={`leg-${index}`}>
                                <Table.TableCell colSize={3}>{t`Leg ${index + 1}`}</Table.TableCell>
                                <Table.TableCell colSize={6}>
                                    {t`${name} ${fuelConsumed} litres`}
                                </Table.TableCell>
                                <Table.TableCell colSize={3} alignEnd align="right">
                                    {legFormattedAmount(leg)}
                                </Table.TableCell>
                            </Table.TableRow>
                        )
                    })}
                </Table.TableBody>
            </Table>
        </Table.TableContainer>
    )
}
